<template>
  <div v-if="isChile()" id="consignments-content">
    <div class="options mb-4">
      <div class="columns is-variable reverse-columns is-justify-content-space-between mb-0">
        <div class="column">
          <div class="is-align-items-center is-flex-desktop has-text-centered-mobile is-vcentered is-centered">
            <button
              id="button-filter"
              class="button is-small is-button-secondary mr-2"
              @click="filterIsShowed = !filterIsShowed">
              <span class="icon is-small">
                <i class="fas fa-filter" />
              </span>
              <span>Filtrar</span>
            </button>
            <button
              id="button-excel"
              class="button is-small is-button-secondary mr-2"
              :disabled="!enableExcelButton"
              @click="onClickExcelButton">
              <span class="icon is-small">
                <i class="far fa-file-excel" />
              </span>
              <span>Excel</span>
            </button>
            <p id="filter-message" class="message-result is-block-mobile">{{ messageResult }}</p>
          </div>
        </div>
        <div class="search column is-two-fifths-tablet is-two-fifths-desktop">
          <b-field>
            <b-input
              id="search-input"
              v-model="filters.searchInputValue"
              class="is-primary"
              type="search"
              icon="search"
              icon-clickable
              :disabled="!investors.length"
              placeholder="búsqueda"
              size="is-small"
              title="Búsqueda en: identificador, creado por, total consignado, código CMF, identificador de cliente"
              @blur="triggerFilter"
              @keyup.native.enter="triggerFilter" />
          </b-field>
        </div>
      </div>
      <Transition duration="500" name="fade">
        <div v-if="filterIsShowed" id="filter-card" class="filter mt-1">
          <div class="columns is-centered reverse-columns">
            <div class="column is-one-third-desktop">
              <b-field label="Rango de fechas">
                <b-datepicker
                  id="date-filter"
                  v-model="dates"
                  locale="es-ES"
                  class="test"
                  placeholder="Clic para seleccionar"
                  icon="calendar"
                  icon-pack="fa"
                  range
                  size="is-small"
                  :mobile-native="false"
                  trap-focus
                  :date-formatter="dateFormatter"
                  @input="triggerFilter" />
              </b-field>
              <b-button
                class="btn-clear"
                label="Restaurar filtros"
                type="is-default"
                icon-left="arrow-rotate-left"
                size="is-small"
                outlined
                @click="restoreFilters" />
            </div>
            <div class="column is-half-desktop">
              <b-field label="Vehículo de inversión" expanded>
                <b-taginput
                  id="consignment-filter-investor"
                  v-model="filters.selectedInvestorId"
                  :allow-new="false"
                  :open-on-focus="true"
                  field="name"
                  icon="label"
                  autocomplete
                  rounded
                  type="is-info-light"
                  size="is-small"
                  :has-counter="false"
                  :data="investorsOptions"
                  @input="triggerFilter"
                  @typing="filteredInvestorsOptions" />
              </b-field>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import currentUser from '@/ui/mixins/current-user';
import locale from '@/ui/mixins/locale';
import dateFormatter from '@/ui/mixins/date-formatter';
import { setDateOfMonth } from '@/infrastructure/date';

const firstDayOfMonth = 1;
const ISOFormatDateWithSlash = 'YYYY/MM/DD';

const firstDateOfMonth = setDateOfMonth(new Date(), firstDayOfMonth).toString(ISOFormatDateWithSlash);
const defaultStartDate = new Date(firstDateOfMonth);
const defaultEndDate = new Date();
const defaultRangeDate = [defaultStartDate, defaultEndDate];

export default {
  mixins: [
    currentUser,
    locale,
    dateFormatter
  ],
  props: {
    investors: {
      type: Array,
      default: /* istanbul ignore next */ () => this.investors
    },
    enableExcelButton: {
      type: Boolean,
      default: false
    },
    messageResult: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      investorsOptions: this.investors,
      filterIsShowed: false,
      dates: defaultRangeDate,
      filters: {
        from: defaultStartDate,
        to: defaultEndDate,
        selectedInvestorId: this.investors,
        searchInputValue: ''
      }
    };
  },
  mounted() {
    this.investorsOptions = this.investors;
    this.triggerFilter();
  },
  methods: {
    onClickExcelButton() {
      this.$emit('excelButtonClicked', {});
    },
    filteredInvestorsOptions(text) {
      this.investorsOptions = this.investors.filter(option => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    restoreFilters() {
      this.dates = defaultRangeDate;
      this.filters = {
        from: defaultStartDate,
        to: defaultEndDate,
        selectedInvestorId: this.investors,
        searchInputValue: ''
      };
      this.triggerFilter();
    },
    triggerFilter() {
      const [from, to] = this.dates;
      const eventArguments = {
        selectedInvestorId: this.filters.selectedInvestorId.map(investor => investor._id),
        searchInputValue: this.filters.searchInputValue,
        from: from.toISOString().substring(0, 10),
        to: to.toISOString().substring(0, 10)
      };
      this.$emit('filter', eventArguments);
      this.sendFilterAction();
    },
    async sendFilterAction() {
      try {
        const { user } = this.currentUser();
        const action = {
          country: this.locale(),
          view: this.$route.name,
          user_id: user._id,
          user_rol: user.rol,
          executed_at: new Date(),
          action: 'filter'
        };
        if (user.rol === 'INVESTOR' && user.investorsIds) {
          action.metadata = { investorsIds: user.investorsIds };
        }
        // this.$socket.emit('action', action);
      } catch (error) {
        this.$log.error('Error al enviar action filter', error);
      }
    }
  }
};
</script>
<style scoped>
.filter {
  background-color: #FFF;
  padding: 1em;
  border: 1px solid rgba(0, 173, 168, 0.4);
  border-radius: 6px;
  width: 100%;
}

@media screen and (min-width: 769px) {

}
@media screen
and (min-width: 740px)
and (max-width: 1024px)
and (orientation: landscape) {
  .options .columns {
    display: flex !important;
    justify-content: space-between;
  }
  .options .columns .column {
    -webkit-box-flex: 0 !important;
    -ms-flex: none !important;
    flex: none !important;
    width: 50% !important;
  }
}

@media screen
and (max-width: 768px)
and (orientation: portrait) {
  .message-result {
    margin-top: 0.75rem !important;
  }
  .columns .column{
    width: 100% !important;
  }
  .options button, .btn-clear {
    display: block;
  }

  .options button, .options select, .btn-clear {
    width: 100%;
    margin-bottom: 2px;
  }

  .reverse-columns {
    flex-direction: column-reverse;
    display: flex;
  }
}
</style>
<style lang="scss">
@media screen
and (max-width: 768px){
  .search{
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
  input#date-filter, #search-input, .filter .control{
    width: 100% !important;
  }
  #button-filter{
    margin-bottom: 0.5rem !important;
  }
}
input#date-filter, #search-input {
  background: #FFF !important;
  border: 1px solid #dbdbdb;
}

.input, .select select, .control input.input, textarea {
  background: #FFF !important;
}

.filter label {
  font-weight: 500 !important;
  font-size: 0.85em;
}

.filter .tag:not(body) {
  background-color: rgba(0, 173, 168, 0.15) !important;
}
.message-info{
  border-radius: 10px !important;
}
</style>
